import React from 'react';
import ReactDOM from 'react-dom';
import Lift from './Lift';

ReactDOM.render(
  <Lift />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js